import styled from "styled-components";
import { colors } from "../../../../theme/theme";

export const ContactForm = styled.div`  

`;

export const Card = styled.div`
max-width: 940px;

`;

export const CardBody = styled.main` 
    /* padding: 20px; */
    /* padding-top: 20px; */
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    

    label { 
        color: ${colors.greyscale.darker_grey};

        margin-top: 5px;
    }

    input { 
        border-radius: 5px;
        border: 1px solid ${colors.greyscale.light_grey};
        padding: 5px;
        width: 480px;
    }

    select { 
        width: 480px;
    }

    textarea { 
        width: 480px;
    }
`;

export const CardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    /* border-top: 1px solid ${colors.greyscale.light_grey}; */


`;

export const PageTitle = styled.div`
    border-bottom: 1px solid ${colors.greyscale.light_grey};

    h1 { 
        font-size: 24px;
        color: ${colors.greyscale.darker_grey};
    }
    margin-bottom: 16px;
    
`;